import { z } from 'zod';
import { CustomErrorParams, CustomErrorType, Validation } from '@mews/framework';
import { Product } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { checkIsDateTimeVisible } from './util';

export enum AddProductFormCardFormKeys {
    'productId' = 'productId',
    'count' = 'count',
    'consumedUTC' = 'consumedUTC',
}

export const useAddProductFormCardSchema = (serviceProducts: Product[]) => {
    return z
        .object({
            [AddProductFormCardFormKeys.productId]: Validation.String.Required.default(''),
            [AddProductFormCardFormKeys.count]: Validation.Number.MaxPositiveInteger.default(1),
            [AddProductFormCardFormKeys.consumedUTC]: Validation.DateTime.Utc.optional(),
        })
        .refine(
            (data) => {
                const isDateTimeRequired = checkIsDateTimeVisible(data.productId, serviceProducts);
                return !isDateTimeRequired || !!data.consumedUTC;
            },
            {
                message: TextKey.ValidateRequired,
                path: [AddProductFormCardFormKeys.consumedUTC],
                params: {
                    errorType: CustomErrorType.Other,
                    textKey: TextKey.ValidateRequired,
                } satisfies CustomErrorParams,
            }
        );
};

export type AddProductFormCardFormValues = z.infer<ReturnType<typeof useAddProductFormCardSchema>>;
